import React from 'react';

import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import {Typography, Box, Stack, useTheme} from '@mui/material';

import {conditionsToRegex, conditionsToText} from '../../../shared/utils/utils';

interface PasswordStrengthProps {
  password: string;
}

export function PasswordStrength({password}: PasswordStrengthProps) {
  const theme = useTheme();
  const hasSpaces = /\s/.test(password ?? '');

  return (
    <>
      {Object.keys(conditionsToRegex).map(cond => {
        const conditionValid = conditionsToRegex[cond].test(password || '');
        const color = conditionValid
          ? theme.palette.success.main
          : theme.palette.misc.light;

        return (
          <Box
            key={cond}
            sx={{
              display: 'inline-block',
              padding: '4px 12px',
              borderRadius: '12px',
              backgroundColor: color,
              color: theme.palette.text.primary,
              marginBottom: '6px',
              marginRight: '6px',
            }}
          >
            <Stack
              direction="row"
              spacing={0.5}
              sx={{
                alignItems: 'center',
              }}
            >
              <CheckRoundedIcon fontSize="small" />
              <Typography
                sx={{
                  fontSize: 12,
                }}
              >
                {conditionsToText[cond]}
              </Typography>
            </Stack>
          </Box>
        );
      })}
      {hasSpaces && (
        <Typography
          sx={{
            color: theme.palette.error.main,
            fontSize: 12,
            marginTop: '5px',
          }}
        >
          Leerzeichen sind nicht erlaubt.
        </Typography>
      )}
    </>
  );
}

export default PasswordStrength;
